import React from "react";
import {
  FaBolt,
  FaEthereum,
  FaShieldAlt,
  FaHandsHelping,
} from "react-icons/fa";

function FeatureCard({ icon: Icon, title, description }) {
  return (
    <div className="feature-style-one hover-active-item">
      <div className="content d-flex flex-column items-center">
        <div className="icon">
          <Icon size={40} />
        </div>
        <h4>{title}</h4>
        <p>{description}</p>
      </div>
      <img
        src="https://validthemes.net/site-template/robok/assets/img/shape/9.png"
        alt="shape"
      />
    </div>
  );
}

function BenefitsBSC() {
  const features = [
    {
      title: "Low Fees and Fast Transactions",
      description:
        "BSC’s efficient infrastructure enables low-cost, rapid transactions—ideal for DeFi and NFT platforms.",
      icon: FaBolt,
    },
    {
      title: "Ethereum Compatibility",
      description:
        "BSC’s EVM compatibility allows for easy migration of Ethereum-based projects to BSC, expanding your reach.",
      icon: FaEthereum,
    },
    {
      title: "Scalable and Secure",
      description:
        "Xeer ensures scalability and top-tier security, delivering robust solutions that accommodate high transaction volumes.",
      icon: FaShieldAlt,
    },
    {
      title: "Comprehensive Support",
      description:
        "From development to deployment and beyond, Xeer Technology provides end-to-end support for your BSC project.",
      icon: FaHandsHelping,
    },
  ];

  return (
    <div
      className="feature-style-one-area default-padding bg-gray blurry-shape-right-bottom"
      style={{
        backgroundImage:
          "url(https://validthemes.net/site-template/robok/assets/img/shape/3.png)",
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <div className="site-heading">
              <h4 className="sub-title">Our Features</h4>
              <h2 className="title split-text-right split-text-in-right split-lines">
                Benefits of Binance Smart Chain Development with Xeer Technology
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="fade-up-anim">
          <div className="row">
            <div className="col-xl-12">
              <div className="feature-style-one-items">
                {features.map((feature, idx) => (
                  <FeatureCard key={idx} {...feature} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BenefitsBSC;
